import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './views/pages/login/login.component';
import { RegisterComponent } from './views/pages/register/register.component';
import { TellerComponent } from './pageui/teller/teller.component';
import { DashboarduiComponent } from './pageui/dashboardui/dashboardui.component';
import { DrawComponent } from './pageui/draw/draw.component';
import { OperatorsComponent } from './pageui/operators/operators.component';
import { authGuard } from './auth.guard';
import { RunningbetsComponent } from './pageui/runningbets/runningbets.component';
import { ReportComponent } from './pageui/report/report.component';
import { WinningbetsComponent } from './pageui/winningbets/winningbets.component';
import { HotnumbersComponent } from './pageui/hotnumbers/hotnumbers.component';
import { KeycodeComponent } from './pageui/keycode/keycode.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'dashboard',
        component: DashboarduiComponent,
        // canActivate: [authGuard],
      },
      {
        path: 'teller',
        component: TellerComponent,
        data: {
          title: 'Teller Information',
        },
      },
      {
        path: 'draw',
        component: DrawComponent,
        data: {
          title: 'Draw Information',
        },
      },
      {
        path: 'hotnumbers',
        component: HotnumbersComponent,
        data: {
          title: 'Hot Numbers',
        },
      },
      {
        path: 'keycode',
        component: KeycodeComponent,
        data: {
          title: 'Key Code Information',
        },
      },
      {
        path: 'operator',
        component: OperatorsComponent,
        data: {
          title: 'Group Information',
        },
      },
      {
        path: 'runningbet',
        component: RunningbetsComponent,
        data: {
          title: 'Running Bet Amounts',
        },
      },
      {
        path: 'grossreport',
        component: ReportComponent,
        data: {
          title: 'Gross Report',
        },
      },
      {
        path: 'winningbets',
        component: WinningbetsComponent,
        data: {
          title: 'Winning Bets Report',
        },
      },
      {
        path: 'theme',
        loadChildren: () =>
          import('./views/theme/theme.module').then((m) => m.ThemeModule),
      },
      {
        path: 'base',
        loadChildren: () =>
          import('./views/base/base.module').then((m) => m.BaseModule),
      },
      {
        path: 'buttons',
        loadChildren: () =>
          import('./views/buttons/buttons.module').then((m) => m.ButtonsModule),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./views/forms/forms.module').then((m) => m.CoreUIFormsModule),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./views/charts/charts.module').then((m) => m.ChartsModule),
      },
      {
        path: 'icons',
        loadChildren: () =>
          import('./views/icons/icons.module').then((m) => m.IconsModule),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./views/notifications/notifications.module').then(
            (m) => m.NotificationsModule
          ),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./views/widgets/widgets.module').then((m) => m.WidgetsModule),
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page',
    },
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page',
    },
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      // relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
